import { Box, CircularProgress } from '@mui/material';

export function LoadingIndicator() {
  return (
    <Box sx={{ display: 'flex', justifyContent: 'center', p: 2 }}>
      <CircularProgress size={24} />
    </Box>
  );
}
